import { render, staticRenderFns } from "./DraftItem.vue?vue&type=template&id=c52e37ca&scoped=true"
import script from "./DraftItem.vue?vue&type=script&lang=js"
export * from "./DraftItem.vue?vue&type=script&lang=js"
import style0 from "./DraftItem.vue?vue&type=style&index=0&id=c52e37ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52e37ca",
  null
  
)

export default component.exports